import React, { FC, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { TextField, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles, withStyles } from '@mui/styles'
import capitalizeFirstLetter from '../../utils/capitalizeFirstLetter'

const useStyle = makeStyles((theme: Theme) => ({
  input: {
    marginBottom: 16,
    padding: '8px 0',
    fontSize: 16,
  },
  errorField: {
    fontSize: 12,
    color: theme.palette.error.main,
    textAlign: 'left',
    marginTop: -16,
  },
}))

const CustomTextField = withStyles((theme: Theme) => ({
  root: {
    '& label': {
      color: theme.palette.primary.dark,
    },
    '&:hover label': {
      color: theme.palette.primary.main,
    },
    '&:active label': {
      color: theme.palette.primary.dark,
    },
    '& input:after': {
      borderBottom: `1px solid ${theme.palette.info.light}`,
    },
  },
}))(TextField)

interface InputFieldProps {
  labelName: string
  inputName: string
  inputType: string
  required?: boolean
}

export const InputField: FC<InputFieldProps> = ({ labelName, inputName, inputType, required }) => {
  const classes = useStyle()
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const error = errors[inputName]

  const errorMessage = useMemo(() => {
    const message = error?.message.replace(inputName, '')
    return capitalizeFirstLetter(message)
  }, [inputName, error])

  return (
    <>
      <CustomTextField
        variant="standard"
        className={classes.input}
        required={required}
        id={inputName}
        label={labelName}
        {...register(inputName)}
        type={inputType}
      />
      {error && (
        <Typography variant="body1" gutterBottom className={classes.errorField}>
          {errorMessage}
        </Typography>
      )}
    </>
  )
}

export default InputField
